module.exports = __webpack_public_path__ + "img/PICT0010.623796d9.jpg";